<n-slide-window *ngIf="pageReady" class="top-index" [(visible)]="windowVisible" width="6rem" [showMask]="true"
    (onHide)="close()">
    <n-header>
        <h1>
            {{i18n.title.detail}}
        </h1>
    </n-header>
    <div class="monitor-details">
        <n-lv [simpleMode]="SWITCH.IS_SIMPLE_MODE">
            <!-- 检查项 -->
            <n-lv-item [label]="i18n.label.name">{{data.name}}</n-lv-item>
            <!-- 检查时间 -->
            <n-lv-item [label]="i18n.label.time">{{data.checkTime || UNPLACEHOLDER}}</n-lv-item>
            <!-- 检查结果 -->
            <n-lv-item [label]="i18n.label.result">
                <!-- 先展示总体结果 -->
                <svg class="icon result-icon" [ngClass]="{'uploading': +data.checkResult === CheckResult.Checking}">
                    <use [attr.xlink:href]="str.getSvg | fn :+data.checkResult"/>
                </svg>
                <span>{{i18n.getResultStr | fn: +data.checkResult : data.skipByUser }}</span>
                <!-- 再每个控制器单独展示 -->
                <div *ngFor="let item of data.nodeInfoArr">
                    <span [innerHTML]="i18n.getController | fn :item.node: item.info"></span>
                </div>
            </n-lv-item>
            <!-- 检查方法 -->
            <n-lv-item [label]="i18n.label.method">
                <span [innerHTML]="data.method"></span>
            </n-lv-item>
            <!-- 检查标准 -->
            <n-lv-item [label]="i18n.label.criterion">
                <span [innerHTML]="data.criterion"></span>
            </n-lv-item>
            <!-- 建议 -->
            <n-lv-item [label]="i18n.label.suggestion">
                <span [innerHTML]="data.suggestion"></span>
            </n-lv-item>
        </n-lv>
    </div>

    <n-footer>
        <button nButton id="detail-check-result-upgrade_confirm_button" [label]="i18n.closeBtn" (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
